var _jsxFileName = "/repo/packages/webassets/src/components/Header/wrench/components/mobile-nav/SubMenuItem.tsx",
  _this = this;
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect, useState } from 'react';
import { List } from '@wds/list';
export var useDocument = function useDocument() {
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    myDocument = _useState2[0],
    setMyDocument = _useState2[1];
  useEffect(function () {
    setMyDocument(document);
  }, []);
  return myDocument;
};
export var SubMenuItem = function SubMenuItem(_ref) {
  var _doc$location$pathnam;
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$name = _ref.name,
    name = _ref$name === void 0 ? '' : _ref$name,
    _ref$path = _ref.path,
    path = _ref$path === void 0 ? '' : _ref$path,
    _ref$url = _ref.url,
    url = _ref$url === void 0 ? '' : _ref$url,
    _ref$openInNewWindow = _ref.openInNewWindow,
    openInNewWindow = _ref$openInNewWindow === void 0 ? false : _ref$openInNewWindow,
    _ref$show = _ref.show,
    show = _ref$show === void 0 ? true : _ref$show,
    _ref$metrics = _ref.metrics,
    metrics = _ref$metrics === void 0 ? '' : _ref$metrics;
  var itemTitle = name || title;
  var itemURL = path || url;
  var doc = useDocument();
  if (!itemTitle || !itemURL || !show) return null;
  var currentPath = (_doc$location$pathnam = doc === null || doc === void 0 ? void 0 : doc.location.pathname) !== null && _doc$location$pathnam !== void 0 ? _doc$location$pathnam : '';
  var isActive = path.startsWith(currentPath);
  return /*#__PURE__*/React.createElement(List.Item, Object.assign({
    key: itemTitle,
    isNavigable: true,
    navigationTarget: itemURL,
    "data-sm-metrics": metrics
  }, openInNewWindow === true && {
    target: '_blank',
    rel: 'noopener noreferrer'
  }, {
    color: isActive ? 'primary' : undefined,
    marked: isActive,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 44,
      columnNumber: 5
    }
  }), itemTitle);
};
export default SubMenuItem;
//# sourceMappingURL=SubMenuItem.js.map